import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import NotFoundTableRow from "../NotFoundTableRow";
import IconButton from '@mui/material/IconButton';
import CopyIcon from "@mui/icons-material/FileCopy";
import {LABELS as _LABELS} from "../../language";

const LABELS=_LABELS.adminPage;

const styles = theme => ({
    root: {
        width: "98%",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: theme.spacing(1),
        overflowX: "auto"
    },
    table: {
        minWidth: 700
    },
    tableHead: {
        // padding: 5,
        // minWidth: 130
    },
    tableRowTitle: {
        display: "inline-block"
        // width: 95
    },
    capitalize: {
        textTransform: "capitalize"
    },
    saveIcon: {
        color: "#009be5",
        cursor: "pointer"
    }
});

class ReduxTableRow extends React.Component {
    copyToClip = (e, url) => {
        let textField = document.createElement("textarea");
        textField.innerText = url;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand("copy");
        textField.remove();
    };

    render() {
        const { classes, item = {}, shareUrl } = this.props;
        const expiry = item.expiry;
        const driver = item.driver || {};
        const vehicle = item.vehicle || {};
        const acId = item.accountSerial;

        const url = `${shareUrl}/${acId}/live/${item.code}`;
        return (
            <TableRow hover>
                <TableCell>
                    <Button
                        color="primary"
                        style={{ justifyContent: "left" }}
                        onClick={e => this.props.onSelect(item)}
                    >
                        {driver.id && (
                            <div className={classes.capitalize}>
                                {`${driver.firstName} ${driver.lastName}`}
                            </div>
                        )}
                        {vehicle.id && (
                            <div className={classes.capitalize}>
                                {`${vehicle.name}`}
                            </div>
                        )}
                    </Button>
                </TableCell>
                {/* <TableCell>{`${item.type}`}</TableCell> */}
                <TableCell>{`${item.status}`}</TableCell>
                <TableCell>
                    {`${this.props.formatDate(expiry)}`}
                    {` ${this.props.formatTime(expiry)}`}
                </TableCell>
                <TableCell>
                    {url}
                    <IconButton
                        aria-label="copy"
                        onClick={e => this.copyToClip(e, url)}
                    >
                        <CopyIcon color="primary" />
                    </IconButton>
                </TableCell>
                <TableCell>
                    {`${this.props.formatDate(item.createdDate)}`}
                    {` ${this.props.formatTime(item.createdDate)}`}
                </TableCell>
            </TableRow>
        );
    }
}

export class ReduxTable extends React.Component {
    state = {
        order: "asc"
    };

    handleChangePage = (event, page) => {
        const { limit } = this.props;
        this.props.handleChange({ page, limit });
    };

    handleChangeRowsPerPage = event => {
        const limit = event.target.value;
        const { page } = this.props;
        this.props.handleChange({ page, limit });
    };

    render() {
        const { classes, items = [], count = 1000 } = this.props;
        const { page, limit } = this.props;

        return (
            <React.Fragment>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{LABELS.detail}</TableCell>
                            {/* <TableCell>Type</TableCell> */}
                            <TableCell>{LABELS.status}</TableCell>
                            <TableCell>{LABELS.expiry}</TableCell>
                            <TableCell>{LABELS.link}</TableCell>
                            <TableCell>{LABELS.created}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(items) &&
                            items.map((item, i) => (
                                <ReduxTableRow
                                    item={item}
                                    key={i}
                                    classes={classes}
                                    onSelect={this.props.onSelect}
                                    shareUrl={this.props.shareUrl}
                                    formatDate={this.props.formatDate}
                                    formatTime={this.props.formatTime}
                                />
                            ))}
                    </TableBody>
                </Table>
                <NotFoundTableRow items={items} />
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
                    component="div"
                    count={count}
                    rowsPerPage={limit}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelRowsPerPage={LABELS.rowsperpage}
                />
            </React.Fragment>
        );
    }
}

ReduxTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ReduxTable);
